/*
 * @Author: wyh
 * @Date: 2018-07-02 17:45:28
 * @Last Modified by: wyh
 * @Last Modified time: 2018-07-03 17:19:35
 * @Description: 创建文字图片
 */
import { Injectable } from "@angular/core";

@Injectable()
export class CreateImage {
  constructor() {}

  cheateImg(imgOptions: imgOptions) {
    console.log("--------------", imgOptions);
    //获取2d的上线文开始设置相关属性
    let canvas = imgOptions.canvas;
    canvas.width = imgOptions.canvasWidth;
    canvas.height = imgOptions.canvasHeight;
    let ctx = canvas.getContext("2d");

    //绘制文字
    ctx.font = imgOptions.font;
    ctx.fillStyle = imgOptions.color;

    let drawStartX = (imgOptions.canvasHeight - 56) / 2 + imgOptions.offsetX;
    let drawStartY = imgOptions.canvasHeight / 2 + imgOptions.offsetY;

    //绘制背景色
    ctx.fillStyle = imgOptions.backgroundColor;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    //设置字体颜色
    ctx.font = imgOptions.font;
    ctx.textBaseline = "middle";
    ctx.fillStyle = imgOptions.color;
    ctx.fillText(imgOptions.text, drawStartX, drawStartY);

    return canvas.toDataURL();
  }
}

export class imgOptions {
  canvas: any; //canvas对象，必填，不填写默认创建一个canvas
  canvasWidth = 128; //canvas的宽度
  canvasHeight = 128; //canvas的高度
  font = "56px ''"; //文字样式
  text = "航"; //需要绘制的文本
  color = "#FFFFFF"; //文字的颜色
  backgroundColor = "#EEC46D"; //背景颜色
  offsetX = 0; //x偏移量
  offsetY = 0; //y偏移量
}



// WEBPACK FOOTER //
// ./src/services/common/createImage.ts